import { render, staticRenderFns } from "./discrete.vue?vue&type=template&id=74aba944&"
import script from "./discrete.vue?vue&type=script&lang=js&"
export * from "./discrete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/dataPanel/discrete.vue"
export default component.exports